var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSkeletonImage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "507px",
    height: "440px",
    viewBox: "0 0 507 440",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Skeleton_Image_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDFE2-UI---Info_ServiceGuide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skeleton_Image_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L507,0 L507,440 L0,440 Z",
    id: "Skeleton/Rectangle-(Background/Mask)",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(203, 167)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image/Outlined",
    transform: "translate(20, 10)",
    fill: "#D9D9D9",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3333333,6.66666667 L53.3333333,53.3333333 L6.66666667,53.3333333 L6.66666667,6.66666667 L53.3333333,6.66666667 Z M53.3333333,0 L6.66666667,0 C3,0 0,3 0,6.66666667 L0,53.3333333 C0,57 3,60 6.66666667,60 L53.3333333,60 C57,60 60,57 60,53.3333333 L60,6.66666667 C60,3 57,0 53.3333333,0 Z M37.1333345,29.5333322 L27.1333345,42.4333318 L20,33.8000011 L10,46.6666667 L50,46.6666667 L37.1333345,29.5333322 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Image-loading-..",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#B8B8B8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 100
  }, "Image loading ..")))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSkeletonImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/skeleton_image.57bb44e52128c13f206c4067a21aebbe.svg";